
// breakpoint settings

export const MOBILE_BREAKPOINT = 768;
export const FULL_BREAKPOINT = 960;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/config/options.js